export const PINNED_WIDGETS_KEY = 'pinned-widgets';
